import styled from 'styled-components';
import { getRutas } from "../../services/authentication.js"
import { useParams,useNavigate } from 'react-router-dom';
import {useDispatch,useSelector} from 'react-redux';
import { useEffect,useState } from 'react'
import {setStp,setNroRuta,setMenuRuta,dataRutas} from "../../redux/actions.js"
import SteperBottom from './steperBottom.jsx'
import VerticalStepper  from'./verticalStepper.jsx'
import Flotante from '../flotante.jsx'
import excelIco from "../../imgs/exel.png" ;
import {mobile} from "../../services/services.js"



const Container=styled.div`
	display:flex;
	position:relative;
	flex-direction:row;
	font-family: 'Poppins', sans-serif;
 `;

const ContainerFlotante=styled.div`
	position:absolute;
	top:75px;
	right:1vw;
`

 const ContainerVerticaStepper=styled.div`
 	width:25vw;
 	height:80vh; 	
 	display:flex;
 	justify-content:end;
 		overflow:auto;
	&::-webkit-scrollbar{
		background-color:white;
		width:1px};
	::-webkit-scrollbar-thumb{
		background:#01578c;
		border-radius:25px};
	::-webkit-scrollbar:horizontal{display:none}
  	@media (max-width:850px) {
  		display:none
  	};
  	
  `;


 const ContainerReproductor=styled.div`
  	width:100%;
  	position:relative; 
 	display:flex;
  	flex-direction:column;
  	justify-content:center;
  	align-items:center;
  	
  `;

const BackButton=styled.button`
	position:absolute;
	left:2vw;
	top:5vh;
	width:95px;
	height:25px;
	background-color:#09b5c1;
	border:none;
	border-radius:5px;
	transition:all 300ms;
	color:white;
	font-family: 'Poppins', sans-serif;

	@media (max-width:600px) {
    	width:65px;
    	top:20px;
    	height:20px;
  	};

	&:hover{
		background-color:orange;
		scale:1.05
	}

  `;

const Reproductor=styled.video`
	height:50vh;
	border-radius:25px;
	margin:30px;
	@media (max-height:600px) {
    	height:45vh
  	};
  	@media (max-width:700px) {
    	height:34vh
  	};
  	@media (max-width:400px) {
    	height:28vh
  	};
 `;



const Titulo=styled.div`
	font-size:35px;
	color:purple;
	@media (max-width:7400px) {
    font-size:25px
  	};
  	@media (max-width:600px) {
    font-size:15px;

  	};
`;

const NombreRuta=styled.div`
	position:absolute;
	right:2vw;
	top:55px;
	transition:all 300ms;
	&:hover{
		background-image: linear-gradient(
        45deg,
        #CA4246 27.666%, 
        #E16541 27.666%, 
        #E16541 29.333%, 
        #F18F43 29.333%, 
        #F18F43 40%, 
        #8B9862 40%, 
        #8B9862 50.666%, 
        #476098 50.666%, 
        #476098 63.333%, 
        #A7489B 63.333%);
        -webkit-background-clip: text;
  		-webkit-text-fill-color: transparent;
  		background-size: 100%;
  		scale:1.05
  	}
`;

const Contador=styled.div`
	position:absolute;
	right:3vw;
	top:5vh;
	color:orange
`;






export default function PasosRuta(){	
   	const dispatch=useDispatch();	
  	let params=useParams();
	let navigate=useNavigate();
	let {id}=params;
	const dataRuta=useSelector(state=>state.dataRutas[id-1]);	
	const step=useSelector(state=>state.paso);
	let [totalSteps,setTotalSteps]=useState(0);
	let [dataOrdenada,setDataOrdenada]=useState({}) ;
	

	dispatch(setMenuRuta(1));
	dispatch(setNroRuta(id));

	useEffect(()=>{
		if(!dataRuta){
			
			let carga=async()=>{
				try{	
					let DAtaRutas=await getRutas();
    				await dispatch(dataRutas(DAtaRutas));	 	 
				}catch(err){alert("sesion expirada");console.log(err)}
  			};

		carga();
	}
	},[dataRuta,dispatch]);

	useEffect(()=>{
		if(dataRuta){
			
			setTotalSteps( dataRuta.Tutorials.length);
    		setDataOrdenada( dataRuta.Tutorials.sort( (a,b)=>a.Ruta_Tutorial.paso - b.Ruta_Tutorial.paso ) );
    	}
	},[dataRuta])

	





	let validar=()=>{
		if (!mobile() & id==="3") {return true}
			else return false
	};	

	const handleNext = () => {
    	dispatch(setStp(step+1));

  	};

  	const handleBack = () => {
    	dispatch(setStp(step-1));
  	};

	 let backToMenu=()=>{
	 	dispatch(setMenuRuta(0));
	 	dispatch(setStp(0));
	 	navigate("/Home/Tutoriales/rutas%20de%20implementacion")
	 }

	 
	return(
			<div>			
				{dataOrdenada.length>0?
				<Container>

					{id==="3"?null:
					<ContainerVerticaStepper>
							<VerticalStepper totalSteps={totalSteps} step={step} pasos={dataOrdenada}  nroPaso={dataOrdenada[step].Ruta_Tutorial.paso}/>
					</ContainerVerticaStepper>}	

					<ContainerReproductor>

						<BackButton onClick={backToMenu}>Menu rutas </BackButton>
											{validar()?<ContainerFlotante>
							<Flotante rutaIco={excelIco} texto="descarga el formato de migracion" archivo="migracion.xlsx" />
						</ContainerFlotante>:null}
						{validar()?null:<NombreRuta>{dataRuta.name}</NombreRuta>}
						<Titulo><b>{dataOrdenada[step].name.toUpperCase()}</b></Titulo>
						<Contador><b>{`${dataOrdenada[step].Ruta_Tutorial.paso}/${totalSteps}`}</b></Contador>
						<Reproductor src={dataOrdenada[step].video}  controls="controls"  />			
						{id==="3"?null:<SteperBottom totalSteps={totalSteps} step={step} next={handleNext} preview={handleBack} />}	
					</ContainerReproductor>	
				
				</Container>:<div>cargando..</div>}
			</div>

		)
}